import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../../../dishesState/dishesContext';
import Text from 'components/Text/Text';
import style from './DropdownMenu.module.scss';

export const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IDishesContext>(DishesContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByDishLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByDishA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('DishesA-Z')}
						checked={sortBy === 'DishesA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByDishZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('DishesZ-A')}
						checked={sortBy === 'DishesZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};
